module.exports = __webpack_public_path__ + "img/tpc-28.7db800a1.jpg";